import { render, staticRenderFns } from "./Spload.vue?vue&type=template&id=74f6706c&scoped=true&"
import script from "./Spload.vue?vue&type=script&lang=js&"
export * from "./Spload.vue?vue&type=script&lang=js&"
import style0 from "./Spload.vue?vue&type=style&index=0&id=74f6706c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f6706c",
  null
  
)

export default component.exports